// extracted by mini-css-extract-plugin
export default {"wrapper":"Ez-z","viewport":"Fz-z","container":"Gz-z","slide":"Hz-z"};